<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "HotIcon"
})
</script>

<template>
  <v-icon color="red" large>mdi-fire</v-icon>
</template>

<style scoped>

</style>